import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  skeleton: {
    transform: "none",
    minHeight: "276px",
    minWidth: "300px",
    width: "100%",
    height: "100%",
    marginTop: "12px",
  },
  map: {
    marginTop: "12px",
    minHeight: "276px",
    
    width: "100%",
    "& div": {
      borderRadius: "8px !important",
    },
    "& .gm-svpc": {
      display: "none",
    },
    "& .gm-style-mtc": {
      display: "none",
    },
    "& .gm-fullscreen-control": {
      display: "none",
    },
  },
  mapTitle: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#465869",
    marginBottom: "24px",
  },
  windowContainer: {
    padding: "5px 5px 0px 5px",
  },
  windowContent: {
    marginBottom: "5px",
  },
  title: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#9CA6AF",
    whiteSpace: "nowrap",
    marginRight: "5px",
    fontFamily: "Manrope !important",
  },
  description: {
    fontSize: "12px",
    color: "#465869",
    fontFamily: "Manrope !important",
  },
}));
